export let InteractionTriggerIconType;

(function (InteractionTriggerIconType) {
  InteractionTriggerIconType["Interact"] = "interact";
  InteractionTriggerIconType["Look"] = "look";
  InteractionTriggerIconType["Speak"] = "speak";
  InteractionTriggerIconType["Attack"] = "attack";
})(InteractionTriggerIconType || (InteractionTriggerIconType = {}));